var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08915 2.06497C2.21115 1.92258 2.34495 1.875 2.44995 1.875H8.97473C9.45798 1.875 9.84973 1.48325 9.84973 1C9.84973 0.516751 9.45798 0.125 8.97473 0.125H2.44995C1.78585 0.125 1.18205 0.434012 0.760215 0.926358C0.341957 1.41453 0.125 2.05136 0.125 2.69231V10.3077C0.125 10.9486 0.341957 11.5855 0.760215 12.0736C1.18205 12.566 1.78585 12.875 2.44995 12.875H3C3.48325 12.875 3.875 12.4832 3.875 12C3.875 11.5168 3.48325 11.125 3 11.125H2.44995C2.34495 11.125 2.21115 11.0774 2.08915 10.935C1.96357 10.7885 1.875 10.5644 1.875 10.3077V2.69231C1.875 2.4356 1.96357 2.21154 2.08915 2.06497Z",
    fill: "#008CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38462 3.125C5.98068 3.125 5.125 4.44678 5.125 5.69231V13.3077C5.125 14.5532 5.98068 15.875 7.38462 15.875H13.6154C15.0193 15.875 15.875 14.5532 15.875 13.3077V5.69231C15.875 4.44678 15.0193 3.125 13.6154 3.125H7.38462ZM6.875 5.69231C6.875 5.41479 6.9676 5.19049 7.08276 5.04975C7.19644 4.91081 7.30772 4.875 7.38462 4.875H13.6154C13.6923 4.875 13.8036 4.91081 13.9172 5.04975C14.0324 5.19049 14.125 5.41479 14.125 5.69231V13.3077C14.125 13.5852 14.0324 13.8095 13.9172 13.9503C13.8036 14.0892 13.6923 14.125 13.6154 14.125H7.38462C7.30772 14.125 7.19644 14.0892 7.08276 13.9503C6.9676 13.8095 6.875 13.5852 6.875 13.3077V5.69231Z",
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.08c15bcbe0b996401694a8efa0d7221e.svg";
export { ForwardRef as ReactComponent };